<template>
  <div style="margin-top:200px;padding-top:200px;">
    <h3 class="notFoundText">
      The page you have requested could not be located.
      <br />
      <br />Please click
      <a href="/">here</a> to return home.
    </h3>
  </div>
</template>
<script>
export default {}
</script>
<style scoped>
.notFoundText {
  font-weight: normal;
  font-family: 'Open Sans', Arial, Verdana, sans-serif;
  font-size: 18px;
}
</style>